import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { useToast } from '../hooks/use-toast';
import { adminForgotPassword } from '../lib/adminApi';
import { Mail, Loader2, ArrowLeft, CheckCircle2 } from 'lucide-react';

export default function AdminForgotPassword() {
  const { toast } = useToast();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await adminForgotPassword(email.trim().toLowerCase());
      setDone(true);
    } catch (err) {
      toast({ title: 'Could not send reset email', description: err?.response?.data?.detail || 'Please try again.' });
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-neutral-950 text-white grid place-items-center p-6" data-testid="admin-forgot-page">
      <div className="w-full max-w-md">
        <div className="rounded-2xl bg-white text-neutral-900 p-7 shadow-2xl">
          {done ? (
            <div className="text-center" data-testid="admin-forgot-sent">
              <div className="w-14 h-14 rounded-full bg-emerald-50 grid place-items-center text-emerald-600 mx-auto"><CheckCircle2 size={28} /></div>
              <h1 className="font-display text-2xl mt-4">Check your inbox</h1>
              <p className="text-sm text-neutral-600 mt-2">
                If <span className="font-medium">{email}</span> matches an admin account, a password-reset link has been sent. It's valid for 30 minutes.
              </p>
              <Link to="/admin/login"><Button className="w-full h-11 mt-6 bg-teal-800 hover:bg-teal-900 text-white"><ArrowLeft size={14} className="mr-1.5" /> Back to sign in</Button></Link>
            </div>
          ) : (
            <>
              <div className="flex items-center gap-2 text-teal-800"><Mail size={16} /><span className="text-xs uppercase tracking-widest">Password reset</span></div>
              <h1 className="font-display text-2xl mt-2">Reset your admin password</h1>
              <p className="text-sm text-neutral-500 mt-1">Enter your admin email. We'll send you a link that's valid for 30 minutes.</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div><Label>Email</Label><Input type="email" className="h-11 mt-1.5" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@waantravel.com" data-testid="admin-forgot-email" required /></div>
                <Button type="submit" disabled={busy} className="w-full h-11 bg-teal-800 hover:bg-teal-900 text-white" data-testid="admin-forgot-submit">
                  {busy ? (<><Loader2 size={16} className="mr-1.5 animate-spin" /> Sending…</>) : 'Send reset link'}
                </Button>
                <div className="text-center">
                  <Link to="/admin/login" className="text-xs text-neutral-500 hover:text-neutral-900 underline underline-offset-2">Back to sign in</Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
